import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="39" height="39" viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg" {...props}><g id="Styles-v2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity=".6"><g id="Sent" fill="#9B9B9B"><path d="M39 0L0 19.5l11.72 2.85 17-11.74-12.68 13.38 13.21 11.76L39 0zM14.62 39l5.3-7.2-5.3-4.71V39z" id="$" /></g></g></svg>);